<span [class]="'status-badge ' + type" [class.is-loading]="!loaded" [innerText]="label"></span>
